<div class="label-wrapper" [class]="status.toLowerCase()" [ngClass]="{'noBorder': noBorder}">
    <div class="dot"></div>
    <div class="label">
        {{status}}
    </div>
</div>